<template>
    <div>

        <p class="mt-6 has-text-white" v-if="loading"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading available content...</p>

        <section v-else>
            <div class="columns" v-if="ondemandSessions.length > 0">
                <div class="column is-12">
                    <div v-if="registration.conference.is_show_tracks">
                        <div v-for="(track, index) in ondemandSessions">
                            <h4 class="track-title has-text-white" :class="{'mt-0': index === 0}">
                                <i class="fad fa-code-branch mr-3"></i><strong class="has-text-white">{{ track.title }}</strong> Track
                            </h4>
                            <on-demand-session :registration="registration" :session="session" v-for="session in track.sessions" v-if="session.is_visible"/>
                        </div>
                    </div>
                    <div v-else>
                        <on-demand-session :registration="registration" :session="session" v-for="session in ondemandSessions" v-if="session.is_visible" />
                    </div>
                </div>
            </div>
            <section v-else>
                <ui-card class="pt-4 pl-4 pr-6">
                    <div class="columns is-gapless mb-6 pt-5">
                        <div class="column is-narrow is-size-5"><i class="far fa-fw fa-info-circle mr-4"></i></div>
                        <div class="column">
                            <div class="has-text-weight-bold is-size-5">There is no On-Demand Content currently available for this conference.</div>
                            <div class="mt-4 pr-6">
                                On-Demand Content may be added later or the content has expired and is no long available. If this is a live conference then On-Demand Content may not be posted until the sessions have concluded and have been processed. Please contact the event organizer for more information.
                            </div>
                            <div class="mt-4 pr-6 has-text-weight-bold">
                                <i class="far fa-fw fa-arrow-right mr-2"></i>Please, check back later!
                            </div>
                        </div>
                    </div>
                </ui-card>
            </section>
        </section>


    </div>
</template>

<script>
    import {client as http} from "../../../http_client";
    import moment from "moment";
    import UiCard from "../../../components/UiCard";
    import OnDemandSession from "./OnDemandSession.vue";

    export default {
        components: {OnDemandSession, UiCard},
        props: ["registrationId"],
        data: function() {
            return {
                registration: {
                    conference: {
                        sessions: []
                    }
                },
                loading: true
            };
        },
        computed: {
            ondemandSessions: function() {
                let sessions = this.registration.conference.sessions.filter(session => session.type === "on-demand");
                if (this.registration.conference.is_show_tracks) {
                    sessions.forEach(session => {
                        session.track = this.getSessionTrack(session);
                    });

                    // group by track
                    sessions = sessions.reduce((acc, session) => {
                        let track = this.getSessionTrack(session);
                        if (!acc[track.id]) {
                            acc[track.id] = {
                                title: track.title,
                                sessions: []
                            };
                        }
                        acc[track.id].sessions.push(session);
                        return acc;
                    }, {});

                    // sort by track title
                    sessions = Object.values(sessions).sort((a, b) => {
                        if (a.title < b.title) {
                            return -1;
                        }
                        if (a.title > b.title) {
                            return 1;
                        }
                        return 0;
                    });

                    // sort sessions by title
                    sessions.forEach(track => {
                        track.sessions.sort((a, b) => {
                            if (a.title < b.title) {
                                return -1;
                            }
                            if (a.title > b.title) {
                                return 1;
                            }
                            return 0;
                        });
                    });
                }

                return sessions;
            }
        },
        methods: {
            loadRegistration: function(force) {
                http.get("app/registrations/" + this.registrationId, {force}).then(response => {
                    this.registration = response.data;
                    this.loading = false;

                    this.registration.conference.sessions.sort((a, b) => {
                        if (a.title < b.title) {
                            return -1;
                        }
                        if (a.title > b.title) {
                            return 1;
                        }
                        return 0;
                    });

                    console.log(this.registration.conference.is_show_tracks, "show tracks");

                    // Sum up log minutes and time for each session
                    let logTotalsBySession = {};
                    this.registration.reg_record_log.forEach(log => {
                        if (!logTotalsBySession[log.session_id]) {
                            logTotalsBySession[log.session_id] = {
                                minutes: 0,
                                time: 0
                            };
                        }
                        if (log.minutes > 0) {
                            logTotalsBySession[log.session_id].minutes += log.minutes;
                            logTotalsBySession[log.session_id].time += log.time;
                        }
                    });

                    // assign the total recorded time and minutes to each session for progress bars
                    this.registration.conference.sessions.forEach(session => {
                        let log = logTotalsBySession[session.id];
                        if (log) {
                            session.recorded_minutes = log.minutes;
                            session.recorded_time = log.time;
                        }
                    });
                });
            },
            getSessionTrack: function(session) {
                return this.registration.conference.tracks.find(track => track.id === session.track_id);
            }
        },
        mounted() {
            this.loadRegistration(true);
        }
    };
</script>

<style lang="scss" scoped>
    .video-frame {
        border-radius: 5px;
        border: 1px solid #e7e7e7;
        padding: 10px;
        line-height: 0;
        width: 222px;
        height: 135px;


        img {
            max-width: 200px;
        }
    }
</style>

<style lang="scss">
    .session-progress .progress {
        height: 0.25rem !important;
    }

    h4.track-title {
        font-size: 1.25rem;
        font-weight: normal;
        margin-top: 4.5rem;
        margin-bottom: 1.5rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
    }
</style>
